<template>
  <v-flex>
    <v-container>
      <v-card class="mx-auto px-4 py-8" min-width="100%">
        <v-list-item>
          <transition name="accordion">
            <markdown-it-vue
              v-if="!is_empty(pages[path])"
              class="md-body"
              :content="pages[path]"
              :options="options"
            />
          </transition>
        </v-list-item>
      </v-card>
    </v-container>
  </v-flex>
</template>

<script>
import {mapState, mapMutations} from 'vuex'

import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'

export default {
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    options: {
      markdownIt: {
        html: true,
        linkify: true,
      },
    },
    DOCS_COMMON_ERROR: '# Temporary error',
  }),
  computed: {
    ...mapState({
      pages: (state) => state.docs.pages,
    }),
  },
  methods: {
    ...mapMutations({
      setContent: 'docs/setContent',
    }),
  },
  created: function() {
    if (this.is_empty(this.pages[this.path])) {
      this.getDocs(this.path)
        .then((res) => {
          this.setContent({name: this.path, value: res.data})
        })
        .catch((error) => {
          this.setContent({
            name: this.path,
            value: this.DOCS_COMMON_ERROR,
          })
        })
    }
  },
  components: {
    MarkdownItVue,
  },
}
</script>
